import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnChanges {

  _id: string = '';
  _deployStats: string = '';
  _deployStatsData: string = '';
  _deployStatsData_message: string = '';
  _sgdbData: string = '';
  _sgdbData_id: string = '';
  _sgdbData_type: string = '';
  _sgdbData_username: string = '';
  _sgdbData_password: string = '';
  _username: string = '';
  _artifacts: any[] = [];
  _webappURL: string = '';
  _ini: string = '';
  _loginString: string = '';

  @Input() protheusSelected: Object = {}
  @Input() bases: Array<Object> = []

  ngOnChanges(): void {
    if(Object.keys(this.protheusSelected).length !== 0 && this.protheusSelected !== undefined ) {
      this._id = this.protheusSelected['id'];
      this._deployStats = this.protheusSelected['deployStats'];
      this._deployStatsData = this.protheusSelected['deployStatsData'];
      this._deployStatsData_message = this.protheusSelected['deployStatsData']?.message; //conferir porque não aparece
      this._sgdbData = this.protheusSelected['sgdbData'];
      this._sgdbData_id =  this.protheusSelected['sgdbData']?.databaseId;
      this._sgdbData_type = this.protheusSelected['sgdbData']?.type || this.protheusSelected['sgdbData']?.templateId;
      this._sgdbData_username = this.protheusSelected['sgdbData']?.username;
      this._sgdbData_password = this.protheusSelected['sgdbData']?.password;
      this._artifacts = this.protheusSelected['artifacts'];
      this._username = this.protheusSelected['username'];

      const appserverSpec = this.protheusSelected['specs'].appserver.find(spec => spec.name === 'appserver-service') || this.protheusSelected['specs'].appserver[0];
      const multiprotocolport = appserverSpec.modifiedIni.drivers.multiprotocolport;
      const hasBroker = this._artifacts.some((artifact) => artifact.kind.toLowerCase() === "broker");

      this._artifacts.forEach(element => {
        const hasMpp = multiprotocolport !== undefined
          && multiprotocolport === '1'
          && appserverSpec.modifiedIni.general['app_environment'] !== '';

        if ((hasMpp && !hasBroker && element.name === 'smartclient') || (hasMpp && hasBroker && element.kind.toLowerCase() === "broker" && element.name === 'webapp')) {
          this._webappURL = 'http://' + element['ip'] + ':' + element['port'] + '/webapp';
        } else if ((!hasBroker && element.name === 'webapp') || (hasBroker && element.kind.toLowerCase() === "broker" && element.name === 'webapp')) {
            this._webappURL = 'http://' + element['ip'] + ':' + element['port'];
        };
      });

      if (appserverSpec['spec'] !== undefined) {
        if (appserverSpec.spec.spec.ini !== undefined && appserverSpec.spec.spec.ini !== '') {
          this._ini = JSON.stringify(appserverSpec.spec.spec.ini, null, 2);
        }
      }
      if (appserverSpec.modifiedIni !== undefined && appserverSpec.modifiedIni !== '') {
        this._ini = JSON.stringify(appserverSpec.modifiedIni, null, 2);
      }

    }
    if (this.bases !== undefined && this.bases['tipo'] !== undefined) {
      if (this.bases['tipo'] === 'congelada' ) this._loginString = 'Admin | 1234'
      if (this.bases['tipo'] === 'inicializada' ) this._loginString = 'Admin | (sem senha)'
    }

    if (this.bases !== undefined && this.bases['preset'] !== undefined) {
      if (this.bases['preset'] === 'congelada' ) this._loginString = 'Admin | 1234'
      if (this.bases['preset'] === 'iniciada' ) this._loginString = 'Admin | (sem senha)'
    }

  }
}
